import { cn } from '@fortem-monorepo/js-utilities'
import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ManagementReport } from '@fortem-monorepo/web-sdk'

import { useManagementReportQuery } from '@/pages/funds/management-report/query'
import { ManagementReportWidget } from '@/pages/funds/management-report/types'

export interface FixedIncomeGridProps extends ManagementReportWidget {}

export const FixedIncomeGrid: React.FC<FixedIncomeGridProps> = ({ params }) => {
  const query = useManagementReportQuery(params)

  return (
    <Widget>
      <WidgetHeaderWithQuery query={query} title="Fixed Income" />
      <WidgetContent loading={query.isLoading} className={'flex min-h-40'}>
        {Object.entries(query.data?.fixed_income ?? {}).map(([key, data], index) => {
          return (
            <div
              className={cn('w-full', {
                'border-r': index === 0,
              })}
            >
              <WidgetHeaderWithQuery title={key} />
              <WidgetContent className={'flex flex-col flex-1 h-full!'}>
                <CustomAgGrid
                  query={query}
                  rowData={data}
                  domLayout={'autoHeight'}
                  columnDefs={makeColDefs()}
                  key={key}
                  statusBar={{ statusPanels: [] }}
                />
              </WidgetContent>
            </div>
          )
        })}
      </WidgetContent>
    </Widget>
  )
}

const formatter = numberFormatter({
  suffix: '%',
  transformer(val) {
    return val * 100
  },
})

const makeColDefs = () => {
  return createColDefs<
    Required<ManagementReport.GetManagementReportData>['fixed_income'][string][number]
  >([
    {
      field: 'index',
      headerName: 'Bond',
    },
    {
      field: 'position_notional_base',
      headerName: 'Total Exposure',
      valueFormatter: formatter,
      cellClass: 'text-center',
    },
    {
      field: 'wgt_locked_ytm',
      headerName: 'Bucket yield (no cash)',
      valueFormatter: formatter,
      cellClass: 'text-center',
      width: 150,
    },
    {
      field: 'duration',
      cellClass: 'text-center',
      valueFormatter: numberFormatter(),
    },
  ])
}
